import { IRoomCategory } from '@shared/types/room_category';
import { IRoomInput } from '@shared/types/room_input';
import { IRoomSelection } from '@shared/types/room_selection';

export const buildRoomsInput = (data?: Map<IRoomCategory, Partial<IRoomSelection>>) => {
  const results: IRoomInput[] = [];
  if (!data) {
    return results;
  }

  for (const category of Array.from(data.keys())) {
    const selection = data.get(category);
    if (!selection) {
      continue;
    }
    results.push({
      id: selection.id,
      categoryID: category.id,
      quantity: selection.quantity,
      selected: selection.selected,
    });
  }

  return results;
};
